import { buildFailedRequestErrorPayload } from '../buildPayloads/buildFailedRequestErrorPayload.js';
export const trackFailedRequest = (params) => {
    return buildFailedRequestErrorPayload(params);
};
//# sourceMappingURL=trackFailedRequest.js.map